import { Box, Button, Group } from "@mantine/core";
import React from "react";

export function LoadingButton({
  lite,
  fetchNextPage,
  to,
  loading,
  icon,
}: {
  lite?: boolean;
  to?: string;
  loading: boolean;
  fetchNextPage: () => void;
  icon?: React.ReactNode;
}) {
  return (
    <Box>
      <Button
        fullWidth
        variant="light"
        disabled={loading}
        sx={(theme) => ({
          backgroundColor:
            theme.colorScheme === "dark"
              ? theme.colors.dark[6]
              : theme.colors.gray[0],
          color: `${
            theme.colorScheme === "dark" ? theme.white : theme.colors.dark[4]
          } !important`,
          fontWeight: 400,
          height: 28,
        })}
        onClick={() => {
          fetchNextPage();
        }}
      >
        <Group spacing={8}>
          {icon}
          {loading ? "Loading..." : "More"}
        </Group>
      </Button>
    </Box>
  );
}
